export function getDateStr(now) {
  var year = now.getFullYear(); // 年
  var month = now.getMonth() + 1; // 月
  var day = now.getDate(); // 日

  if (day < 10) {
    day = "0" + day;
  }

  if (month < 10) {
    month = "0" + month;
  }
  return year + "-" + month + "-" + day;
}

export function timeSlotChange(val) {
  let startTime, endTime;
  let now = new Date(); //当前日期
  var nowDayOfWeek = now.getDay(); //今天本周的第几天
  var nowDay = now.getDate(); //当前日
  let nowMonth = now.getMonth(); //当前月
  let nowYear = now.getFullYear(); //当前年
  let jd = Math.ceil((nowMonth + 1) / 3);

  // eslint-disable-next-line default-case
  switch (val) {
    case "今天":
      startTime = new Date(now);
      endTime = new Date(now);
      break;
    case "昨天":
      const dayTime = 3600 * 1000 * 24;
      const timestamp = now.getTime() - dayTime;
      startTime = new Date(timestamp);
      endTime = new Date(timestamp);
      break;
    case "本周":
      startTime = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
      endTime = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
      break;
    case "本月":
      startTime = new Date(nowYear, nowMonth, 1);
      endTime = new Date(nowYear, nowMonth + 1, 0);
      break;
    case "本季度":
      startTime = new Date(nowYear, (jd - 1) * 3, 1);
      endTime = new Date(nowYear, jd * 3, 0);
      break;
    case "今年":
      startTime = new Date(nowYear, 0, 1);
      endTime = new Date(nowYear, 11, 31);
      break;
  }
  return [
    getDateStr(startTime) + " 00:00:00",
    getDateStr(endTime) + " 23:59:59",
  ];
}

export function doHandleMonth(month) {
  var m = month;
  if (month.toString().length === 1) {
    m = "0" + month;
  }
  return m;
}

export function getDay(day) {
  var today = new Date();

  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;

  today.setTime(targetday_milliseconds);

  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return [
    tYear + "-" + tMonth + "-" + tDate + " 00:00:00",
    getDateStr(new Date()) + " 23:59:59",
  ];
}
